import styled from 'styled-components';
import {
	blue500, orange500, red500, green600, primary400,
	blue25, orange25, red50, neutral50, green25, accentBlue,
} from '../themes/colors';
/* eslint-disable max-len */

const getVariantColor = ($variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral') => {
	switch ($variant) {
	case 'info':
		return blue500;
	case 'warning':
		return orange500;
	case 'danger':
		return red500;
	case 'success':
		return green600;
	case 'neutral':
		return primary400;
	default:
		return primary400;
	}
};

export const IconWrapper = styled.div<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`
	color: ${({ $variant }) => getVariantColor($variant)};
	.icon {
		font-size: 24px;
		margin-top: -4px;
	}

	svg {
		fill: currentColor;
	}
`;

export const CloseButton = styled.button<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 12px;
	top: 10px;
	color: ${({ $variant }) => getVariantColor($variant)};

	.icon {
		font-size: 24px;
	}

	svg {
		fill: currentColor;
	}
`;

export const SimpleInfoBoxWrapper = styled.div<{ 
	$variant: string; 
	$isExiting: boolean;
	$height: string;
}>`
	
	background-color: ${({ $variant }) =>
		$variant === 'info' ? blue25 :
			$variant === 'warning' ? orange25 :
				$variant === 'danger' ? red50 :
					$variant === 'neutral' ? neutral50 :
						green25};
	border-radius: 2px;
	width: 100%;
	align-items: center;
	height: ${({ $height }) => $height};
	overflow: hidden;
	transition: all 300ms ease-in-out;
`; 

export const SimpleInfoBoxContainer = styled.span`
	padding: 16px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
`;

export const SimpleInfoBoxContentWrap = styled.span`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 12px;
`;

export const SimpleInfoBoxContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const SimpleInfoBoxHeadline = styled.span<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`
	font-size: 16px;
	font-weight: 600;
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
	color: ${({ $variant }) => getVariantColor($variant)};
`;

export const SimpleInfoBoxText = styled.span<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`  
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	font-family: "Red Hat Display", sans-serif;
	color: ${({ $variant }) => getVariantColor($variant)};
`;

export const SimpleInfoBoxContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
`;

export const SimpleInfoBoxLink = styled.a`
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	font-family: "Red Hat Display", sans-serif;
	color: ${accentBlue};
	
	&:hover {
		.icon {
			transform: translateX(4px);
		}
	}

	.icon {
		font-size: 20px;
		margin-left: 2px;
		transition: transform 0.2s ease-in-out;
	}
`;
